import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BankCardIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M24.75 6H7.25C5.59301 6.00176 4.00445 6.58765 2.83277 7.62913C1.6611 8.67062 1.00198 10.0827 1 11.5556H31C30.998 10.0827 30.3389 8.67062 29.1672 7.62913C27.9956 6.58765 26.407 6.00176 24.75 6Z"
        fill="currentColor"
      />
      <path
        d="M1 20.4444C1.00198 21.9173 1.6611 23.3294 2.83277 24.3709C4.00445 25.4124 5.59301 25.9982 7.25 26H24.75C26.407 25.9982 27.9956 25.4124 29.1672 24.3709C30.3389 23.3294 30.998 21.9173 31 20.4444V13.7778H1V20.4444ZM9.75 19.8889C9.75 20.2185 9.64003 20.5408 9.43401 20.8148C9.22798 21.0889 8.93514 21.3025 8.59253 21.4287C8.24992 21.5548 7.87292 21.5878 7.50921 21.5235C7.14549 21.4592 6.8114 21.3005 6.54917 21.0674C6.28695 20.8343 6.10837 20.5373 6.03603 20.214C5.96368 19.8907 6.00081 19.5556 6.14273 19.2511C6.28464 18.9465 6.52496 18.6862 6.83331 18.5031C7.14165 18.32 7.50416 18.2222 7.875 18.2222C8.37228 18.2222 8.84919 18.3978 9.20083 18.7104C9.55246 19.0229 9.75 19.4469 9.75 19.8889Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
